<template>
 <div class="box">
  <div class="box_content">
   <TabTime @onChangeTime="onChangeTime" :titleText="'燃气营收系统数据'" />
        <div class="title">
            <span class="blue-title"></span>
            <span class="title-text">营收数据</span>
        </div>
         <div class="data-item2">
            <div class="item-six">
                <div>
                    <div ><span class="number">-</span><span class="danwei">万</span></div>
                    <div class="total-mo">售气量</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div ><span class="number">-</span><span class="danwei">万</span></div>
                    <div class="total-mo">总售气量</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div><span class="number">-</span><span class="danwei">万</span></div>
                    <div class="total-mo">营收额</div>
                </div>
            </div>
            <div class="item-six">
                <div>
                    <div><span class="number">-</span><span class="danwei">万</span></div>
                    <div class="total-mo">累计营收额</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div ><span class="number">-</span><span class="danwei"></span></div>
                    <div class="total-mo">新增开户用户</div>
                </div>
                <div class="tooline"></div>
                <div>
                    <div ><span class="number">-</span><span class="danwei"></span></div>
                    <div class="total-mo">用户量</div>
                </div>
            </div>
            <div class="item-six">
                <div>
                    <div><span class="number">-</span><span class="danwei"></span></div>
                    <div class="total-mo">累计用户量</div>
                </div>
                
            </div>
        </div> 
         <div class="title">
            <span class="blue-title"></span>
            <span class="title-text">燃气营收数据增长趋势</span>
        </div>
       <div>
     </div>
    </div> 
    </div>
</template>

<script>
import TabTime from './tabTime.vue'
import { shortcuts } from '../utils/index'

export default {
  components: {
    TabTime
  },
  data() {
    return {
      currentPage: 'FirePage',
      currentTime: '',
      currentDay: "",
      tapTravelData: {
        revenue: 0,
        accumRevenue: 0,
        parkUserNum: 0,
        parkTotalUserNum: 0,
      }
    };
  },
  mounted() {
    this.getCurrentDate();
    this.updateTime();
    this.tapTravelApi(shortcuts(0)); // 默认加载"今天"数据
  },
  methods: {
    updateTime() {
      setInterval(() => {
        this.currentTime = new Date().toLocaleTimeString();
      }, 1000);
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const daysOfWeek = ["日", "一", "二", "三", "四", "五", "六"];
      this.formattedDate = `${year}-${month}-${day}`;
      this.currentDay = "星期" + daysOfWeek[date.getDay()];
    },
    onChangeTime(message) {
      this.tapTravelApi(message.date);
    },
    async tapTravelApi(date) {
      try {
        const [startDate, endDate] = date;

        const formatDate = (dateObj) => {
          const year = dateObj.getFullYear();
          const month = String(dateObj.getMonth() + 1).padStart(2, '0');
          const day = String(dateObj.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const requestData = {
          startDay: formatDate(startDate),
          endDay: formatDate(endDate)
        };

        const response = await fetch('http://117.33.227.88:8788/api/getIncomeStatistics', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData)
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const res = await response.json();
        this.processIncomeData(res);
        
      } catch (error) {
        console.error('获取数据失败:', error);
        // 显示错误信息或使用默认数据
        this.tapTravelData = {
          revenue: 0,
          accumRevenue: 0,
          parkUserNum: 0,
          parkTotalUserNum: 0
        };
      }
    },
    processIncomeData(res) {
      const defaults = {
        parkUserNum: 0,
        parkTotalUserNum: 0,
        revenue: 0,
        accumRevenue: 0
      };

      const responseData = { 
        ...defaults, 
        ...(res.data || {}) 
      };

      this.tapTravelData = {
        revenue: responseData.revenue,
        accumRevenue: responseData.accumRevenue,
        parkUserNum: responseData.parkUserNum,
        parkTotalUserNum: responseData.parkTotalUserNum
      };
    }
  }
}
</script>

<style scoped>

* {
  margin: 0;
  padding: 0;
}
.box {
  width: 100%;
  margin-top: -3.9%;
  color: rgb(255, 255, 255);
  /* background: linear-gradient(135deg, #b0d957 0%,#558d40 42%, #457f4d 100%); */
  background: #ffffff;
}

.box_content {
  margin: 0 10px;
}

.title {
  display: flex;
  padding: 14px 0;
  justify-content: flex-start;
}

.blue-title {
  width: 3px;
  height: 16px;
  background-color: #50ba96;
  margin-right: 8px;
}

.title-text {
  font-size: 14px;
 color: #606060;
}

.data-item2 {
  padding: 24px 13px;
  display: flex;
  flex-direction: column;
}

.item-six {
  display: flex;
  justify-content: space-between;
  padding-bottom: 21px;
}

.tooline {
  width: 1px;
  height: 16px;
  background-color: #666666;
}

.number {
  font-size: 20px;
  font-weight: 700;
  color: #666666;
}

.danwei {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}

.total-mo {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.chart-container {
  z-index: 9999;
  width: 100%;
  height: 180px;
  background: #f7f7f7 ;
 }
.chart {
  width: 100%;
  height: 100%;
}
</style>
